<template lang="pug">
  form(@submit.prevent="").upload-files.e-file-uploader
    div(
      @drag.stop.prevent="onDragEnd"
      @dragover.stop.prevent="onDragStart"
      @dragstart.stop.prevent="onDragStart"
      @dragenter.stop.prevent="onDragStart"
      @dragend.stop.prevent="onDragEnd"
      @dragleave.stop.prevent="onDragEnd"
      @drop.stop.prevent="onFileDrop"
    ).upload
      div.upload-content
        div.icon
        div.info
          p.blue Перетащите файлы в эту область
          p Файл не должен превышать 20Мб
      div.file-upload
        label.file-upload__label(for="upload") Загрузить
        input.file-upload__input(
         type="file"
         @change="addFile"
         :multiple="multiple"
        )
      //button.green--text Загрузить
    div(v-if="files && files.length").uploaded
      label Загруженные файлы
      div.uploaded-files
        div(v-for="file in files").file
          div.file-content
            div.img
            div.filename
              p.name {{file.name ? file.name : item.id}}
              p.size {{file.size ? (file.size/1024/1024).toFixed(3) : 0}} Мб
              p(v-if="file.loading").loading Загрузка...
          div.buttons
            button(@click.prevent="deleteFile(file, index)").row-delete
            button(@click.prevent="downloadFile(file)").row-download
    div(v-else).uploaded
      label Нет загруженных файлов
</template>

<script>
  import {core} from '../../api/api-endpoints.js'
  import {coreOffline} from '../../api/api-offline-endpoints.js'
  import userFriendlyEr from '../../utils/userFriendlyEr.js'
  import {WALL} from '../../config/config.js'

  export default {
    name: 'e-file-uploader',
    data () {
      return {
        loading: false,
        dragInProgress: false
      }
    },
    props: {
      entityName: {
        type: String,
        default: 'tko_operator'
      },
      entityId: {
        type: [String, Number],
        default: null
      },
      createDocEndpoint: {
        type: Function,
        // eslint-disable-next-line
        default: function (entityId, entityName, payload = {}) {
          return core.documentUpdateOrCreate()
        }
      },
      fileListEndpoint: {
        type: Function,
        // eslint-disable-next-line
        default: function (entityId, entityName, payload = {}) {
          return core.documents(entityId)
        }
      },
      deleteEndpoint: {
        type: Function,
        default: function (itemId) {
          return core.documentDelete(itemId)
        }
      },
      downloadEndpoint: {
        type: Function,
        default: function (itemId) {
          return core.documentDownload(itemId)
        }
      },
      uploadEndpoint: {
        type: Function,
        default: function (docId) {
          return core.documentUpload(docId)
        }
      },
      multiple: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      items () {
        return this.$sharedServices.store.getters.readUrlEndpoint(this.getEndpoint())
      },
      item () {
        if (this.items && this.items.data && this.items.data.length) {
          return this.items.data[0]
        }
        return null
      },
      files () {
        if (this.item) {
          return this.item.files
        }
        return null
      }
    },
    created () {
      if (this.entityId) {
        this.fetchData()
      }
    },
    methods: {
      onDragStart () {
        this.dragInProgress = true
      },
      onDragEnd () {
        this.dragInProgress = false
      },
      uploadFiles: async function (entityId) {
        let errors = []
        let docId = this.item.id || null
        if (!docId) {
          console.log(entityId)
          let model = Object.assign({}, this.item, {
            entity_id: (entityId || 'Id созд карточки не передан')
          })
          delete model.files
          try {
            this.loading = true
            let response = await this.$sharedServices.store.dispatch('createModel', {
              url: this.createDocEndpoint(),
              data: model,
              action: 'prepend'
            })
            docId = response.id
          } catch (e) {
            console.error(e)
            errors.push('Не удалось создать документ в который вгружаются файлы')
          }
        }
        if (this.files && errors.length === 0) {
          let files = this.files
          for (let i = 0; i < files.length; i++) {
            let file = Object.assign({}, files[i])
            try {
              this.loading = true
              await this.uploadFile(file, docId)
            } catch (e) {
              errors.push('Не удалось загрузить файл')
            }
          }
        }
        this.loading = false
        if (errors.length > 0) {
          this.$swal({
            position: 'center',
            type: 'error',
            title: userFriendlyEr.recognize(errors[0]),
            showConfirmButton: false,
            timer: WALL.ERROR_TIMEOUT
          })
          return Promise.reject(errors[0])
        }
        return Promise.resolve(1)
      },
      uploadFile (fileModel, docId) {
        if (!fileModel.upload) {
          return Promise.resolve(1)
        }
        return this.$sharedServices.store.dispatch('uploadFile', {
          url: this.uploadEndpoint(docId),
          data: fileModel,
          endpoint: null
        })
      },
      deleteFile (file, index) {
        this.$e.confirmBox(
          'Удаленный файл нельзя будет восстановить',
          'Удалить файл?',
          'Удалить'
        ).then(() => {
          this.$sharedServices.store.dispatch('deleteModel', {
            endpoint: null,
            url: this.deleteEndpoint(file.id),
            data: {},
            // if model doesnt create, dont send response and delete from store only
            offline: !file.id
          }).then(() => {
            const model = Object.assign({}, this.item)
            model.files.splice(index, 1)
            this.$sharedServices.store.dispatch('updateModel', {
              endpoint: this.getEndpoint(),
              data: model,
              offline: true
            })
          }).catch(e => {
            console.error(e)
            this.$swal({
              position: 'center',
              type: 'error',
              title: userFriendlyEr.recognize(e),
              showConfirmButton: false,
              timer: WALL.ERROR_TIMEOUT
            })
          })
        })
      },
      onFileDrop (e) {
        this.addFile(e)
      },
      addFile (e) {
        this.onDragEnd()
        let files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }

        for (let file of files) {
          this.saveFile(file)
        }
      },
      createDoc () {
        const model = Object.assign({}, {
          entity_name: this.entityName,
          entity_id: this.entityId,
          errors: {},
          files: []
        })
        return this.$sharedServices.store.dispatch('createModel', {
          url: this.createDocEndpoint(this.entityId),
          endpoint: this.getEndpoint(),
          data: model,
          offline: this.offlineMode(),
          action: 'prepend'
        })
      },
      offlineUpdateFiles ({_id = null, file = null, id = null, loading, loadingPercent}) {
        const model = Object.assign({}, this.item)
        let fileModel = {}
        let index = -1
        if (id === null) {
          fileModel = {
            id: null,
            _id: _id,
            size: file.size,
            name: file.name,
            upload: file,
            loading: loading,
            loadingPercent: loadingPercent
          }
          model.files.push(fileModel)
        } else {
          index = model.files.findIndex(v => v._id === _id)
          fileModel = model.files
          model.files[index] = {
            id: id,
            size: file.size,
            name: file.name,
            upload: null,
            loading: loading,
            loadingPercent: loadingPercent
          }
        }
        return this.$sharedServices.store.dispatch('updateModel', {
          endpoint: this.getEndpoint(),
          data: model,
          offline: true
        })
      },
      saveFileInDoc (file) {
        const _id = +new Date() + '_' + Math.random()
        let loading = (this.item && this.item.id)
        let loadingPercent = 0
        this.offlineUpdateFiles({_id, file, loading, loadingPercent}).then(r => {
          if (this.item && this.item.id) {
            this.uploadFile({
              id: this.item.id,
              upload: file
            }, this.item.id).then(r => {
              loading = false
              this.offlineUpdateFiles({_id, file, id: r.data.id, loading, loadingPercent})
            }).catch(() => {
              loading = false
              this.offlineUpdateFiles({_id, file, loading, loadingPercent})
            })
          }
        })
      },
      saveFile (file) {
        if (!this.item) {
          this.loading = true
          this.createDoc().then(r => {
            this.loading = false
            console.log(r)
            this.saveFileInDoc(file)
          }).catch(e => {
            this.loading = false
            console.error(e)
          })
        } else {
          this.saveFileInDoc(file)
        }
      },
      downloadFile (file) {
        let a = document.createElement('a')
        if (file.id) {
          a.download = file.name
          a.href = this.downloadEndpoint(file.id)
          a.click()
        } else {
          try {
            console.log(file.upload)
            a.href = window.URL.createObjectURL(file.upload)
            a.download = `${file.upload.name}`
            a.click()
          } catch (e) {
            console.error(e)
          }
        }
      },
      getEndpoint () {
        if (!this.offlineMode()) {
          return this.fileListEndpoint(this.entityId, this.entityName)
        }
        return coreOffline.documents(this.$sharedServices.router.currentRoute.name)
      },
      offlineMode () {
        return !this.entityId
      },
      fetchData () {
        const endpoint = this.getEndpoint()
        this.loading = true
        this.$sharedServices.store.dispatch('updateUrlEndpoint', {
          endpoint: endpoint,
          offline: this.offlineMode()
        }).then(() => {
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    }
  }
</script>

<style>
  .e-file-uploader .file-upload {
    position: relative;
    display: inline-block;
  }

  .e-file-uploader .file-upload__label {
    display: block;
    text-align: center;
    width: 97.2px;
    border-radius: 4px;
    background-color: #6fbf15;
    border: none;
    font-size: 12px;
    color: #fff!important;
    padding: 10px;
    transition: .3s;
  }

  .e-file-uploader .file-upload__input {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    font-size: 1;
    width: 0;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
</style>
